module.exports = __webpack_public_path__ + "img/title_txt_day5.329433f9.png";